﻿import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { CloseIconFill } from "@/ImageRepo";
import React from "react";
import "./PopUp.css";

const PopUp = ({ size, children, openPopUp, setOpenPopUp, title }) => {
  return (
    <Dialog
      open={openPopUp}
      className={size}
      fullWidth={true}
      PaperProps={{
        sx: { borderTopLeftRadius: 10, borderTopRightRadius: 10 },
      }}
    >
      <DialogTitle
        variant="h4"
        sx={{
          backgroundColor: "var(--primary-main)",
          color: "var(--default-light)",
        }}
      >
        {title}
        <Box>
          <IconButton
            className="close-button"
            onClick={() => setOpenPopUp(false)}
            sx={{
              width: 15,
              height: 15,
              minWidth: 0,
              minHeight: 0,
              padding: 0,
            }}
          >
            <CloseIconFill
              className="view-data-close-icon"
              style={{ width: 15, height: 15 }}
            />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent style={{ padding: 60 }}>{children}</DialogContent>
    </Dialog>
  );
};

export default PopUp;
